import type { DeepPartial } from '@luna/utils-ts';

import type { Print } from '../../types/Print';

export const printHRFeatureConfig: DeepPartial<Print> = {
    columns: {
        hideCapitalGainTax: true,
        hideTotalProfitAndFee: true,
    },
};
